






import ServiceConfirmationComponent from "@c/Home/Services/ServiceConfirmation/ServiceConfirmationComponent";
export default ServiceConfirmationComponent;
